<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <core-table hide-upsert title="Countries" upsert-max-width="850px" :config="config">
        </core-table>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'

export default {
  data() {
    return {
      config,
    }
  },
  async created() {
  },
  methods: {
  }
}
</script>
